'use client';

import { c as _c } from "react/compiler-runtime";
import cx from 'classix';
import { useAtomValue } from 'jotai/index';
import { currenciesListAtom, currentCurrencyAtom } from '@/features/currency/atoms/currencies-atom';
import { type Listing, type ListingDataView } from '@/features/listing/types/listing-types';
import styles from './listing-rate.module.scss';
interface ListingRateProps {
  rate: Listing['rates'];
  view?: ListingDataView;
  showPerMonth?: boolean;
}
export default function ListingRate(props) {
  const $ = _c(21);
  const {
    rate,
    showPerMonth: t0,
    view: t1
  } = props;
  const showPerMonth = t0 === undefined ? true : t0;
  const view = t1 === undefined ? "isCard" : t1;
  const currency = useAtomValue(currentCurrencyAtom);
  const currencies = useAtomValue(currenciesListAtom);
  let listingPrice = rate.requestedMonthlyRate;
  const listingCurrency = currencies?.[rate.currency];
  if (currencies && listingCurrency?.rate && rate.requestedCurrency !== currency.name) {
    const listingPriceInUSD = rate.monthlyRate / listingCurrency.rate;
    listingPrice = listingPriceInUSD * currency.rate;
  }
  const t2 = styles[`listingRate__${view}`];
  let t3;
  if ($[0] !== t2) {
    t3 = cx(styles.listingRate, t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== currency.prefix) {
    t4 = currency.prefix && <div>{currency.prefix}</div>;
    $[2] = currency.prefix;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  const t5 = Math.ceil(listingPrice);
  let t6;
  if ($[4] !== t5) {
    t6 = <div className={styles.listingRate_label}>{t5}</div>;
    $[4] = t5;
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  let t7;
  if ($[6] !== currency.postfix || $[7] !== currency.prefix) {
    t7 = !currency.prefix && currency.postfix && <div>{currency.postfix}</div>;
    $[6] = currency.postfix;
    $[7] = currency.prefix;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] !== t4 || $[10] !== t6 || $[11] !== t7) {
    t8 = <div className={styles.listingRate_value}>{t4}{t6}{t7}</div>;
    $[9] = t4;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== currency.name || $[14] !== showPerMonth || $[15] !== view) {
    t9 = showPerMonth && <div>{view === "isDetailed" ? currency.name : `${currency.name} / month`}</div>;
    $[13] = currency.name;
    $[14] = showPerMonth;
    $[15] = view;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t3 || $[18] !== t8 || $[19] !== t9) {
    t10 = <div className={t3}>{t8}{t9}</div>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  return t10;
}